import React from 'react'

export default function VisiGiftBudgetPayment() {
  return (
    <div>VisiGiftBudgetPayment</div>
  )
}
